/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const graphMutationAddNodeClientIdMax = 36;

export const graphMutationAddNodeClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const graphMutationAddNodeContentTypeClientIdMax = 36;

export const graphMutationAddNodeContentTypeClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const graphMutationAddNodeTypeDescriptionMax = 2000;

export const GraphMutationAddNode = zod.object({
  clientId: zod
    .string()
    .min(1)
    .max(graphMutationAddNodeClientIdMax)
    .regex(graphMutationAddNodeClientIdRegExp)
    .describe(
      'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
    ),
  contentTypeClientId: zod
    .string()
    .min(1)
    .max(graphMutationAddNodeContentTypeClientIdMax)
    .regex(graphMutationAddNodeContentTypeClientIdRegExp)
    .optional()
    .describe(
      'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
    ),
  contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  occurredAt: zod.string().optional(),
  subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
  typeDescription: zod.string().min(1).max(graphMutationAddNodeTypeDescriptionMax).optional(),
  typeName: zod.string().min(1).optional(),
  value: zod
    .object({
      booleanValue: zod.boolean().nullish(),
      dateValue: zod.string().nullish(),
      datetimeValue: zod.string().nullish(),
      numericValue: zod.number().nullish(),
      stringValue: zod.string().nullish(),
    })
    .optional(),
  valueType: zod.enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME']).optional(),
  variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
});

export type GraphMutationAddNode = zod.input<typeof GraphMutationAddNode>;
export type GraphMutationAddNodeOutput = zod.output<typeof GraphMutationAddNode>;
